import { Typography } from '@mui/material'
import { Button } from 'utoniq-ui'

import { BaseLayout, Head } from '@/components/layouts'
import { config } from '@/config'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'

import { MailRegisterForm, MailRegisterFormProps } from './MailRegisterForm'

export type State = {}

export type Action = {
  onSubmitMailRegister: MailRegisterFormProps['onSubmitMailRegister']
  onLogout: () => Promise<void>
}

export const MailRegisterTemplate: Template<State, Action> = ({
  onSubmitMailRegister,
  onLogout,
}) => {
  const { t } = useTranslation('mailRegister')
  const { routerNames } = useRouter()

  return (
    <>
      <Head title={routerNames.MailRegister} />
      <BaseLayout
        margin
        header={{
          title: t('title'),
          right: (
            <Button
              variant="text"
              sx={{
                whiteSpace: 'nowrap',
                px: 0,
                ml: -3,
                mr: -1,
              }}
              onClick={onLogout}
            >
              {t('logout')}
            </Button>
          ),
        }}
      >
        <TextCell />
        <MailRegisterForm onSubmitMailRegister={onSubmitMailRegister} />
      </BaseLayout>
    </>
  )
}

const TextCell: Cell = () => {
  const { t } = useTranslation('mailRegister')
  return (
    <CellFrame sx={{ pt: 2, pb: 6 }}>
      <Typography variant="body2" color="text.primary">
        {t('desc', { appName: config.appName })}
      </Typography>
    </CellFrame>
  )
}
